// extracted by mini-css-extract-plugin
module.exports = {"image":"_2w_ZA1q0ukW9WKnJ7NEyoY","top":"_3y4RGc4S8EwxcHy0JmawyA","bottom":"_28S43-jsCOKwWddBeUDEDm","center":"_2Z27A2PRTepj4PdG8gCk8y"};